export type PublicLegalDocument = {
  kind: "terms" | "privacy";
  title: string;
  updated: string;
  /** Only explicitly platform-scoped documents may replace the sales middle. */
  scope?: "platform" | "owner";
  format?: "rich-text" | "plain-text";
  dateLabel?: string;
  sections: Array<{ h: string; body: string }>;
};

export const LEGAL_CONTENT_ANCHOR = "legal-content";